import { useLazyQuery as useApolloLazyQuery } from '@apollo/client'

function useLazyQuery(query, options = {}) {
  const newOptions = { fetchPolicy: 'cache-and-network', ...options }

  return useApolloLazyQuery(query, newOptions)
}

export default useLazyQuery
